export const cutString = (str: string, numberLettersToLeave: number) =>
  str.slice(0, numberLettersToLeave)
